<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sCsjRr/tc-custom/9780830899128.jpg?1696870400349" alt="This image is the cover for the book Romans 9-16, Reformation Commentary on Scripture Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Romans 9-16, Reformation Commentary on Scripture Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Writing to the early Christians in Rome, the apostle Paul said, "Do not be conformed to this world, but be transformed by the renewal of your mind, that by testing you may discern what is the will of God, what is good and acceptable and perfect" (Rom 12:2 ESV). Perhaps more than any other New Testament epistle, Paul's letter to the Romans has been the focus of Christian reflection throughout the church's history, transforming the minds and convicting the hearts of believers. Sixteenth-century reformer Martin Luther reflected the church's longstanding emphasis on this portion of the canon: "Let the Epistle to the Romans be the door and the key to holy Scripture for you; otherwise you will never enter into a proper understanding and comprehension of the Bible." In this volume of the Reformation Commentary on Scripture, Philip Krey and Peter Krey guide readers with care through a diversity of Reformation-era commentary on the second half of Paul's letter to the Roman church. Among the difficult issues addressed by Paul and commented on by early modern exegetes were the predestination of God's elect, the destiny of Israel, the role of Gentiles in salvation history, the ethical demands of the Christian life, and the Christian's relationship to the state. Here, readers will encounter familiar voices and discover lesser-known figures from a variety of theological traditions, including Lutherans, Reformed, Radicals, Anglicans, and Roman Catholics. The volume draws on a variety of resources, including commentaries, sermons, treatises, and confessions, much of which appears here for the first time in English. Gathering together these Reformation-era reflections, it provides resources for contemporary preachers, enables scholars to better understand the depth and breadth of Reformation biblical commentary and aids the ongoing transformation of the minds—and lives—of people today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip D. W. Krey, Peter D. S. Krey
      </h2>
      
      <p class="authorDescription body article"><p>Philip D. W. Krey (PhD, University of Chicago) is president emeritus and professor emeritus of early and medieval church history at Lutheran Theological Seminary at Philadelphia (Pennsylvania). He is the author of several books, including <em>Nicholas of Lyra's Apocalypse Commentary</em> and <em>For All the Saints: A Short History of the Church</em>, and the co-editor of <em>Luther's Spirituality</em> as well as the volume on Hebrews in the Ancient Christian Commentary on Scripture.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?770b4270